module.exports = {
  SERVER_PORT: process.env.VUE_APP_SSR_SERVER_PORT || 3000,
  APP_ROOT: process.env.VUE_APP_ROOT,
  HOST: process.env.HOST || "http://localhost:3000",
  API_URL: process.env.VUE_APP_API_URL || "http://graphql/graphql",
};
